import React, {FC} from 'react'
import StylesType from '@/types/StylesType'
import classnames from 'classnames'
import {Checkbox, Col, Row} from "antd";

import './style/DeviceList.less'
import {CheckboxChangeEvent} from "antd/lib/checkbox";
import secondToDay from "@/utils/secondToDay";

export interface DeviceListTypes {
  productIds?:any[];
  onChange?: (arr: any[]) => void;
  onAllSelect?: (bool: boolean) => void
  deviceList?: any[];
  indeterminate?: boolean;
  getDeviceName: (cid: string) => string
}

type deviceListProps = StylesType & DeviceListTypes

const DeviceList: FC<deviceListProps> = props => {
  let {prefixCls = 'gc_device_list_', className, productIds=[], onChange, deviceList=[], indeterminate=false, onAllSelect, getDeviceName} = props
  const allSelected = ():boolean => {
    return deviceList.length === productIds.length
  }
  const getIndeterminate = (): boolean => {
    if(!indeterminate) return false;
    return deviceList.length > productIds.length && productIds.length !== 0
  }
  const onChangeAll = (e: CheckboxChangeEvent) => {
    onAllSelect && onAllSelect(e.target.checked)
  }
  return (
    <>
      <div className={classnames(className, prefixCls + 'device_list')}>
        <Row gutter={[0,10]}>
          <Col>
            <Checkbox indeterminate={getIndeterminate()} checked={allSelected()} onChange={onChangeAll}>全选</Checkbox>
          </Col>
          <Col>
            <Checkbox.Group value={productIds} onChange={onChange}>
              <Row type='flex' gutter={[10, 10]}>
                {deviceList.map(device => {
                  return (
                    <Col>
                      <Checkbox value={device.id} key={device.deviceName || device.cid}>{getDeviceName(device.cid)}<span
                        className={classnames(prefixCls + 'c000045')}>/{
                        secondToDay(
                          device.endTime - 1800 - Number(Math.round(new Date().getTime() / 1000).toString())
                        )}</span></Checkbox>
                    </Col>
                  )
                })}
              </Row>
            </Checkbox.Group>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default DeviceList
